<h2 class="settings-title">
  {{"plan.ct.settings.additional.settings.workload.title" | translate}}

</h2>
<div class="col-16 user-field section">
  <div class="row">
    <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
      <label id="startingBacklogLabel" class="text-uppercase input-label">
        {{"plan.settings.ct.dlg.starting.backlog" | translate}}
      </label>
      @if(backlogForm.get('backlogInput').disabled) {
        <button type="button" class="info-tooltip" [attr.aria-label]="'icon.info.tooltip' | translate" [attr.aria-describedby]="'startingBacklogInfoDesc'" placement="right" ngbPopover="{{'plan.ct.settings.backlog.not.workload.msg' | translate}}" popoverClass="popover-tooltip" container="body" triggers="hover focus" [autoClose]="true">
          <i class="icon-info" aria-hidden="true"></i>
        </button>
        <span id="startingBacklogInfoDesc" class="sr-only">{{'plan.ct.settings.backlog.not.workload.msg' | translate}}</span>
      }
    </div>
  </div>
  <div class="row">
    <div class='col-sm-12'>
      <div>
        <form [formGroup]="backlogForm">
          @if(backlogForm.get('backlogInput').enabled){
          <p-inputnumber
            mode="decimal"
            [useGrouping]="false"
            name="startingBacklogInput"
            inputId="startingBacklogInput"
            autocomplete="off"
            formControlName="backlogInput"
            styleClass="backlog-input"
            [required]="true"
            [min]="0"
            [ariaLabelledBy]="'startingBacklogLabel'"
            [ariaDescribedBy]="invalidBacklogInput ? 'startingBacklogUnit startingBacklogError' : 'startingBacklogUnit'"
            (onInput)="onBacklogInput($event)">
          </p-inputnumber> <span id="startingBacklogUnit" class="side-info">{{"plan.settings.ct.dlg.contacts" | translate}}</span>
          } @else{
            <input pInputText id="startingBacklogInput" class="p-inputnumber-input p-inputnumber backlog-input-disabled" disabled
              [attr.aria-labelledby]="'startingBacklogLabel'" [attr.aria-describedby]="'startingBacklogUnit'">
            <span id="startingBacklogUnit" class="side-info">{{"plan.settings.ct.dlg.contacts" | translate}}</span>
          }
          <div *ngIf="invalidBacklogInput" id="startingBacklogError" role="alert" aria-atomic="true" class="error-message">{{'plan.settings.ct.dlg.contacts.validation'|translate}}</div>
        </form>
      </div>
    </div>
  </div>
</div>
<h2 class="settings-title">
  {{"plan.ct.settings.additional.settings.projected.performance.title" | translate}}
</h2>
<div class="col-16 user-field section">
  <div class="row">
    <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
      <label id="projectedAsaLabel" class="text-uppercase input-label" for="projectedAsaInput">
        {{"plan.ct.settings.projected.asa.threshold" | translate}}
      </label>
    </div>
  </div>
  <div class="row">
    <div class='col-sm-12'>
      <div>
        <form [formGroup]="reverseSolveForm">
          <input pInputText [size]="14" [required]="false"
                 class="p-inputnumber-input asa-input"
                 id="projectedAsaInput"
                 type="text"
                 inputmode="numeric"
                 [min]="0"
                 formControlName="projectedAsa"
                 [attr.aria-labelledby]="'projectedAsaLabel'"
                 [attr.aria-describedby]="invalidProjectedAsa ? 'projectedAsaUnit projectedAsaError' : 'projectedAsaUnit'"
                 (input)="onAsaThresholdInput($event)"
                 data-testid="asaThresholdInput">
          <span id="projectedAsaUnit" class="side-info">
            @if(this.projectedAsa==='--'){
              <span> {{"plan.ct.settings.multiple.values"|translate}}</span>
            }@else{
              <span> {{"plan.ct.settings.misc.seconds" | translate}}</span>
            }
          </span>
          <div *ngIf="invalidProjectedAsa" id="projectedAsaError" role="alert" aria-atomic="true" class="error-message">{{'plan.ct.settings.misc.projectedAsa.validation'|translate}}</div>
        </form>
      </div>
    </div>
  </div>
</div>
